import {useController, useFormContext} from 'react-hook-form';

import {Container, Label, Code} from './styles';
import {NestedKeys} from 'shared/types/key-manipulation';
import {BaseInputProps} from '../..';

export type InlineCodeProps<T = any> = BaseInputProps<T> & {
  name: NestedKeys<T>;
};

const InlineCode = ({label, name}: InlineCodeProps) => {
  const {control} = useFormContext();
  const {field} = useController({control, name});
  return (
    <Container>
      <Label>{label}</Label>
      <Code block>{JSON.stringify(field.value, null, 2)}</Code>
    </Container>
  );
};

export default InlineCode;
